import React__default, { useMemo } from 'react';
import './LabelPrice.scss';

const priceFormatterDollarsAndCents = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
});
const priceFormatterDollarsOnly = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
});
const LabelPrice = ({ price, perDuration, isAddOn, strikethrough, className, ariaLabel, format, }) => {
    const formattedPrice = useMemo(() => {
        // Auto-determine format if not explicitly provided
        const effectiveFormat = format || (price % 1 === 0 ? 'dollarsOnly' : 'dollarsAndCents');
        const formatter = effectiveFormat === 'dollarsOnly'
            ? priceFormatterDollarsOnly
            : priceFormatterDollarsAndCents;
        return formatter.format(price);
    }, [price, format]);
    const isRecurring = !!perDuration;
    return (React__default.createElement("span", { "data-rev-component": 'label-price', "data-price-type": isRecurring ? 'recurring' : null, "data-rev-strikethrough": strikethrough, className: className, "aria-label": ariaLabel },
        isAddOn && '+',
        formattedPrice,
        perDuration && (React__default.createElement("span", { className: 'per-duration' }, perDuration === 'month' ? '/mo' : '/yr'))));
};

export { LabelPrice };
//# sourceMappingURL=LabelPrice.js.map
